let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iD7yW")).then(() => parcelRequire('cAzT1'));